import { render, staticRenderFns } from "./slickBalItem.vue?vue&type=template&id=51a580ce&scoped=true"
import script from "./slickBalItem.vue?vue&type=script&lang=js"
export * from "./slickBalItem.vue?vue&type=script&lang=js"
import style0 from "./slickBalItem.vue?vue&type=style&index=0&id=51a580ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a580ce",
  null
  
)

export default component.exports